export const links = {
  youtube: 'https://www.youtube.com/planoprever',
  facebook: 'https://www.facebook.com/planopreversc',
  linkedin: 'https://www.linkedin.com/company/grupo-prever/',
  instagram: 'https://www.instagram.com/planopreversc/',
  assistancesManual: 'www.planoprever.com.br/manual',
};

export const footerLinks = [
  {
    label: 'NOSSAS UNIDADES',
    href: 'https://www.planoprever.com.br/unidades',
  },
  {
    label: 'CONTATO',
    href: 'https://www.planoprever.com.br/contato',
  },
  {
    label: 'POLÍTICA DE PRIVACIDADE',
    href: 'https://www.planoprever.com.br/politica-privacidade',
  },
];

export const email = 'relacionamento@grupopreversul.com.br';

export const company =
  'Prever Serviços Póstumos de Santa Catarina Ltda CNPJ: 02.153.228/0001-47';

export const tenant = 'prever_sc';

export const state = 'Santa Catarina';

export const slug = 'sc';

export const product = 'Prever Angelus Santa Catarina';

export const brand = 'Prever Angelus';

export const plansLabel = 'Planos Prever Angelus';

export const description =
  'Plano Prever Angelus é referência em assistência familiar no Sul do Brasil. ';

export const coverage = 'Assistência funeral com cobertura nacional';
